import { success, loading, handleErrorException } from 'State/actions';

import * as types from './types';

export const getPage = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.UNIVERSAL_DATA_EXPORT_FETCHING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `UniversalDataExport/GetUniversalDataExportPage`
      );
      const result = response.data.Data;
      dispatch(success(types.UNIVERSAL_DATA_EXPORT_FETCH_SUCCESS, result));
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.UNIVERSAL_DATA_EXPORT_FETCH_ERROR, {
          Title: 'Error',
          Message: 'Could not retrieve page.',
        })
      );
    } finally {
      dispatch(loading(types.UNIVERSAL_DATA_EXPORT_FETCHING, false));
    }
  };
};

export const exportData = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.UNIVERSAL_DATA_EXPORT_FETCHING, true));
      await MPWWebApi.postGenericInsertUpdate(
        'UniversalDataExport/WriteUniversalDataExport',
        data
      );
    } catch (ex) {
      dispatch(
        handleErrorException(ex, types.UNIVERSAL_DATA_EXPORT_FETCH_ERROR, {
          Title: 'Error',
          Message: 'Could not export data.',
        })
      );
    } finally {
      dispatch(loading(types.UNIVERSAL_DATA_EXPORT_FETCHING, false));
    }
  };
};

export const clearErrors = () => {
  return {
    type: types.UNIVERSAL_DATA_EXPORT_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/universaldataexport/state/actions.js